export default __webpack_public_path__ + "static/media/analysis.57ec369c.png";